import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { carouselAPI } from '../../services/api';

export const fetchCarouselItems = createAsyncThunk('carousel/fetchAll', async (params, { rejectWithValue }) => {
  try {
    const response = await carouselAPI.getAll(params);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Failed to fetch carousel items');
  }
});

export const createCarouselItem = createAsyncThunk('carousel/create', async (data, { rejectWithValue }) => {
  try {
    const response = await carouselAPI.create(data);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Failed to create carousel item');
  }
});

export const updateCarouselItem = createAsyncThunk('carousel/update', async ({ id, data }, { rejectWithValue }) => {
  try {
    const response = await carouselAPI.update(id, data);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Failed to update carousel item');
  }
});

export const deleteCarouselItem = createAsyncThunk('carousel/delete', async (id, { rejectWithValue }) => {
  try {
    await carouselAPI.delete(id);
    return id;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Failed to delete carousel item');
  }
});

const carouselSlice = createSlice({
  name: 'carousel',
  initialState: { carouselItems: [], loading: false, error: null, pagination: null },
  reducers: { clearError: (state) => { state.error = null; } },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCarouselItems.pending, (state) => { state.loading = true; })
      .addCase(fetchCarouselItems.fulfilled, (state, action) => {
        state.loading = false;
        state.carouselItems = action.payload.data || [];
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchCarouselItems.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(createCarouselItem.fulfilled, (state, action) => { state.carouselItems.unshift(action.payload); })
      .addCase(updateCarouselItem.fulfilled, (state, action) => {
        const index = state.carouselItems.findIndex(c => c.id === action.payload.id);
        if (index !== -1) state.carouselItems[index] = action.payload;
      })
      .addCase(deleteCarouselItem.fulfilled, (state, action) => {
        state.carouselItems = state.carouselItems.filter(c => c.id !== action.payload);
      });
  },
});

export const { clearError } = carouselSlice.actions;
export default carouselSlice.reducer;
